import Customer from "./customer";
export interface IUser {
  id?: number;
  login_id: string;
  is_enabled?: boolean;
  created?: string;
  customer?: Customer;
  mail_address?: string;
  login_password?: string;
  login_password_confirmation?: string;
  account_supervisor_name?: string;
  account_authority?: number;
  customer_name?: string;
  account_code?: string;
  customer_code?: string;
  administrator_name?: string;
}

export class UserDTO implements IUser {
  public id?: number;
  public login_id = "";
  public name = "";
}

export default class User extends UserDTO {}

export class UserCustomer extends User {}
